<div class="min-vh-100 bg-light">
  <app-header [page]="'Additional Documents'"></app-header>

  <main class="container py-4">
    <div class="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4">
      <div>
        <h4 class="fw-bold mb-1">Additional Documents</h4>
        <div class="text-muted">Upload documents requested for a paused deposit.</div>
      </div>
      <div class="d-flex gap-2 align-items-center">
        <select class="form-select form-select-sm" [(ngModel)]="status" (change)="load(1)">
          <option *ngFor="let option of statuses" [value]="option.value">{{ option.label }}</option>
        </select>
        <button class="btn btn-outline-secondary btn-sm" type="button" (click)="load(page)" [disabled]="loading">Refresh</button>
      </div>
    </div>

    <div class="alert alert-info border-0 shadow-sm">
      <div class="fw-semibold mb-1">Deposits stay paused until approval</div>
      <div class="small">Uploading a document submits it for compliance review. Your wallet is credited only after the document is approved.</div>
    </div>

    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

    <div *ngIf="loading" class="card border-0 shadow-sm">
      <div class="card-body text-center py-5">
        <div class="spinner-border spinner-border-sm me-2"></div>
        Loading document requests...
      </div>
    </div>

    <div class="row g-3" *ngIf="!loading && items.length">
      <div class="col-12" *ngFor="let item of items">
        <div class="card border-0 shadow-sm" [class.border-danger]="requiresAction(item)">
          <div class="card-body">
            <div class="d-flex flex-wrap justify-content-between align-items-start gap-3">
              <div class="flex-grow-1">
                <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
                  <h5 class="mb-0">{{ item.title }}</h5>
                  <span class="badge" [ngClass]="statusClass(item.status)">{{ item.status }}</span>
                  <span *ngIf="item.isBlocking" class="badge text-bg-dark">Deposit hold</span>
                </div>

                <div class="row g-3 small">
                  <div class="col-sm-4">
                    <div class="text-muted">Requested</div>
                    <div>{{ item.requestedAt | date:'medium' }}</div>
                  </div>
                  <div class="col-sm-4" *ngIf="item.depositId">
                    <div class="text-muted">Deposit</div>
                    <div class="font-monospace text-break">{{ item.depositId }}</div>
                  </div>
                  <div class="col-sm-4" *ngIf="item.depositCurrency">
                    <div class="text-muted">Amount</div>
                    <div>{{ item.depositAmount | number:'1.2-2' }} {{ item.depositCurrency }}</div>
                  </div>
                </div>

                <div *ngIf="item.lastRejectionReason" class="alert alert-danger py-2 px-3 mt-3 mb-0 small">
                  <strong>Replacement requested:</strong> {{ item.lastRejectionReason }}
                </div>
              </div>

              <button class="btn" type="button"
                [ngClass]="requiresAction(item) ? 'btn-danger' : 'btn-outline-primary'"
                (click)="open(item)">
                {{ requiresAction(item) ? 'Upload document' : 'View request' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!loading && !items.length" class="card border-0 shadow-sm">
      <div class="card-body text-center py-5">
        <div class="fs-1 mb-2">✓</div>
        <h5>No document requests found</h5>
        <p class="text-muted mb-0">There are no requests matching this filter.</p>
      </div>
    </div>

    <app-pagination *ngIf="meta && meta.totalRows > 0" url="account/additional-documents" [counts]="meta" (refresh)="load($event)"></app-pagination>
    <app-footer></app-footer>
  </main>
</div>
